import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { view, lensPath } from 'ramda'
import { useIntl, FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import DialogViewValidCSVFormat from './AddSubscibers/components/dialogs/DialogViewValidCSVFormat'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessFullScreen from 'app/auth/PaidPlanAccessFullScreen'
import LoadingPage from './AddSubscibers/components/newImport/LoadingPage'
import ImportFromCsv from './AddSubscibers/components/newImport/ImportFromCsv'
import { Box } from '@material-ui/core'
import StepProgressBar from './AddSubscibers/components/newImport/StepProgressBar'

import useStyles from './ImportStyles'
import useOldStyles from './styles'

import {
  STEP_PROGRESS_ONE,
  VIEW_VALID_CSV_FORMAT,
  IMPORT_CSV_TAB,
  IMPORT_EXTERNAL_SOURCE_TAB,
  ADD_ONE_BY_ONE_TAB,
  STEP_PROGRESS_TWO,
  STEP_PROGRESS_THREE,
  CSV_NEW_SAMPLE_FILE_PATH,
  CATEGORY_PLACE_FOR_IMPORT_SCHOOL,
} from './AddSubscibers/constants'
import ImportTabIcon from 'app/components/icons/ImportTabIcon'
import PreviewDataTable from './AddSubscibers/components/newImport/PreviewDataTable'
import {
  useImportCSVData,
  setOptionsLanguages,
  setValidationErrorMessage,
} from 'app/store/importCSV'
import LoadingProgress from './AddSubscibers/components/newImport/LoadingProgress'
import { fetchLanguages } from 'commons/fetchLanguages'
import ConnectedSIS from './AddSubscibers/components/newImport/ImportFromExternalSource'
import { usePlace } from 'commons/usePlace'
import AddOneByOne from './AddSubscibers/AddOneByOne/AddOneByOne'
import useSubscribers from './useSubscribers'
import { useFlag } from '@unleash/proxy-client-react'

const initState = {
  [VIEW_VALID_CSV_FORMAT]: false,
}

export default ({ history, location }) => {
  const { formatMessage } = useIntl()
  const [state, setState] = useState(initState)
  const [activeTab, setActiveTab] = useState(IMPORT_CSV_TAB)
  const classes = useStyles()
  const oldClasses = useOldStyles()
  const dispatch = useDispatch()

  // const history = useHistory()
  const place = usePlace()

  const { handleResetFilter } = useSubscribers()

  const groupCategory = view(
    lensPath(['info', 'category', 'group', 'name']),
    place,
  )

  const validatationErrorMessage = formatMessage({
    id: 'error.inputTriggerFail',
  })

  dispatch(setValidationErrorMessage(validatationErrorMessage))

  const { pathname, state: { tab } = {} } = useLocation()
  const importCSVData = useImportCSVData()
  const {
    activeStep,
    showProgressBar,
    showUploadingProgressBar,
    data: { validationInfo },
  } = importCSVData
  const { percent, uploadingPercent } = validationInfo

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const importedWithErrors =
        activeStep === 3 &&
        validationInfo.type === 'import' &&
        validationInfo.failedSubscribers.length > 0
      const validated = activeStep === 3 && validationInfo.type === 'validate'
      if (showUploadingProgressBar || importedWithErrors || validated) {
        const confirmationMessage =
          'The progress will be cancelled if you leave. Are you sure you want to leave?'
        event.preventDefault()
        event.returnValue = confirmationMessage
        return confirmationMessage
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [
    showUploadingProgressBar,
    activeStep,
    validationInfo.type,
    validationInfo.failedSubscribers.length,
  ])

  const toggleDialogs = (dialogType, isOpen) => {
    setState({
      ...state,
      [dialogType]: isOpen,
    })
  }

  useEffect(() => {
    if (tab) {
      setActiveTab(tab)
    }
  }, [tab])

  const tabs = [
    { label: 'subscribers.import.tabs.tab1.label', type: IMPORT_CSV_TAB },
    {
      label: 'subscribers.import.tabs.tab2.label',
      type: IMPORT_EXTERNAL_SOURCE_TAB,
    },
    { label: 'subscribers.import.tabs.tab3.label', type: ADD_ONE_BY_ONE_TAB },
  ]

  const changeTab = (e) => {
    const { value } = e.target
    setActiveTab(value)
    if (tab) {
      history.replace({ pathname, state: { tab: '' } })
    }
  }

  useEffect(() => {
    const getLanguages = async () => {
      try {
        const response = await fetchLanguages()
        const languages = response.map(({ name, code }) => ({
          name,
          code,
        }))
        dispatch(setOptionsLanguages(languages))
      } catch (err) {
        console.log(err)
      }
    }
    getLanguages()
  }, [])

  const tabElements = tabs.map((tab) => {
    const { label, type } = tab
    const checked = activeTab === type

    const isDisabledTab =
      type === IMPORT_EXTERNAL_SOURCE_TAB &&
      groupCategory !== CATEGORY_PLACE_FOR_IMPORT_SCHOOL

    return (
      <div
        key={label}
        className={clsx(classes.tab, { [classes.activeTab]: checked })}
      >
        <input
          type="radio"
          name="tab"
          value={type}
          checked={checked}
          id={type}
          disabled={isDisabledTab}
          onChange={changeTab}
        />

        <label
          htmlFor={type}
          className={clsx({
            disabledTab: isDisabledTab,
          })}
        >
          <Box component={'span'} display={'flex'}>
            <ImportTabIcon color="#00B2AD" />
          </Box>
          <FormattedMessage id={label} />
        </label>
      </div>
    )
  })

  return (
    <div className="h-100 overflow-auto p-24">
      <PaidPlanAccess
        freePlanComponent={
          <div className={classes.paidBlock}>
            <PaidPlanAccessFullScreen />
          </div>
        }
      >
        {state.isLoading ? (
          <LoadingPage classes={classes} />
        ) : (
          <div className={classes.importTabsWrapper}>
            <div className={classes.tabsWrapper}>{tabElements}</div>
            <div className={classes.tabContentWrapper}>
              {activeTab === IMPORT_CSV_TAB && (
                <>
                  <StepProgressBar />
                  {STEP_PROGRESS_ONE === activeStep && (
                    <ImportFromCsv toggleDialogs={toggleDialogs} />
                  )}
                  {STEP_PROGRESS_TWO === activeStep &&
                    showUploadingProgressBar && (
                      <>
                        <LoadingProgress
                          percent={uploadingPercent}
                          text={formatMessage({
                            id: 'subscribers.import.progressBar.text1',
                          })}
                        />
                      </>
                    )}

                  {STEP_PROGRESS_TWO === activeStep && showProgressBar && (
                    <LoadingProgress
                      percent={percent}
                      text={formatMessage({
                        id: 'subscribers.import.progressBar.validating',
                      })}
                    />
                  )}

                  {/* show warnning column of csv in priview data table */}
                  {STEP_PROGRESS_TWO === activeStep &&
                    !showProgressBar &&
                    !showUploadingProgressBar && (
                      <PreviewDataTable></PreviewDataTable>
                    )}

                  {STEP_PROGRESS_THREE === activeStep &&
                    !showProgressBar &&
                    !showUploadingProgressBar && (
                      <PreviewDataTable></PreviewDataTable>
                    )}

                  {STEP_PROGRESS_THREE === activeStep &&
                    showUploadingProgressBar && (
                      <>
                        <LoadingProgress
                          percent={uploadingPercent}
                          text={formatMessage({
                            id: 'subscribers.import.progressBar.text1',
                          })}
                        />
                      </>
                    )}

                  {STEP_PROGRESS_THREE === activeStep && showProgressBar && (
                    <LoadingProgress
                      percent={percent}
                      text={formatMessage({
                        id: 'subscribers.import.progressBar.text3',
                      })}
                    />
                  )}
                </>
              )}

              {activeTab === IMPORT_EXTERNAL_SOURCE_TAB && <ConnectedSIS />}
              <AddOneByOne
                open={activeTab === ADD_ONE_BY_ONE_TAB}
                onClose={() => setActiveTab(IMPORT_CSV_TAB)}
                onFetch={() => handleResetFilter()}
              />
            </div>
          </div>
        )}
        {state[VIEW_VALID_CSV_FORMAT] && (
          <DialogViewValidCSVFormat
            classes={oldClasses}
            toggleDialogs={toggleDialogs}
            VIEW_VALID_CSV_FORMAT={VIEW_VALID_CSV_FORMAT}
            CSVNewSampleFilePath={CSV_NEW_SAMPLE_FILE_PATH}
          />
        )}
      </PaidPlanAccess>
    </div>
  )
}
